import 'css-chunk:src/feature/provision/ProvisionLogin.module.scss';export default {
  "formContainer": "ProvisionLogin_formContainer"
};